import React, { useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

export default function OverviewChart({ blocks, onSelectBlock }) {
  const data = (blocks || []).map(b => ({
    blockHeight: b.blockHeight,
    blockSumAddr: b.blockSumAddr,
    blockSumUTXO: b.blockSumUTXO
  }));

  const [hoveredHeight, setHoveredHeight] = useState(null);

  const handleBarClick = (dataPoint) => {
    const h = dataPoint?.payload?.blockHeight ?? dataPoint?.blockHeight ?? null;
    if (h && onSelectBlock) onSelectBlock(h);
  };

  const handleChartClick = (state) => {
    const h = state?.activePayload?.[0]?.payload?.blockHeight ?? state?.activeLabel ?? null;
    if (h && onSelectBlock) onSelectBlock(h);
  };

  const handleMouseMove = (state) => {
    const h = state?.activePayload?.[0]?.payload?.blockHeight ?? state?.activeLabel ?? null;
    setHoveredHeight(h ?? null);
  };

  const handleMouseLeave = () => setHoveredHeight(null);

  const XTick = (props) => {
    const { x, y, payload } = props;
    const isActive = Number(payload?.value) === Number(hoveredHeight);
    const fill = isActive ? "#e2e8f0" : "#64748b";
    return (
      <text x={x} y={y + 16} fill={fill} fontSize={12} textAnchor="middle">{payload?.value}</text>
    );
  };

  return (
    <div className="chart-wrapper">
      <ResponsiveContainer width="100%" height={320}>
        <BarChart
          data={data}
          margin={{ top: 8, right: 2, bottom: 8, left: 2 }}
          onClick={handleChartClick}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis dataKey="blockHeight" tick={<XTick />}/>
          <YAxis tick={{ fill: "#64748b", fontSize: 12 }} width={40} />
          <Tooltip cursor={{ fill: "rgba(100,116,139,0.1)" }} contentStyle={{ backgroundColor: "#0b1220", border: "1px solid #334155", color: "#e2e8f0", whiteSpace: "normal", wordBreak: "break-all", maxWidth: 360 }} itemStyle={{ color: "#e2e8f0" }} labelStyle={{ color: "#a3b1c6" }} wrapperStyle={{ maxWidth: 360, overflow: "hidden" }} />
          <Legend />
          <Bar dataKey="blockSumUTXO" name="BIG UTXO (>100 BTC)" fill="#10b981" radius={[4,4,0,0]} onClick={handleBarClick} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
